import type { PurchaseItemType } from "../types";

export const PURCHASE_TYPE_LABELS: Record<
  PurchaseItemType,
  { singular: string; plural: string; color: string }
> = {
  watch: { singular: "Zegarek", plural: "Zegarki", color: "blue" },
  perfume: { singular: "Perfumy", plural: "Perfumy", color: "magenta" },
  game: { singular: "Gra", plural: "Gry", color: "green" },
};

export const GAME_PLATFORM_OPTIONS = [
  "PC",
  "PlayStation 5",
  "PlayStation 4",
  "Xbox Series X|S",
  "Xbox One",
  "Nintendo Switch 2",
  "Nintendo Switch",
  "Steam Deck",
  "iOS",
  "Android",
].map((value) => ({ value }));

export const GAME_FORMAT_LABELS: Record<string, string> = {
  digital: "Cyfrowa",
  physical: "Pudełkowa",
};

export function isPurchaseItemType(v: string | null): v is PurchaseItemType {
  return v !== null && v in PURCHASE_TYPE_LABELS;
}
